import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, StyleValue } from "vue";
import Icon from "./Icon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'RingLoader',
  props: {
    bgColor: null,
    size: null,
    logoColor: null,
    opacity: null
  },
  setup(__props: any) {

const props = __props as {
  bgColor?: string;
  size?: string;
  logoColor?: string;
  opacity?: number;
}



const bgColor = props.bgColor || "#000";
const opacity = props.opacity || 0.5;
const size = props.size || "5em";
const logoColor = props.logoColor || "#fff";

const style = computed<StyleValue>(() => {
  return {
    display: "flex",
    color: "red",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    width: "100%",
    height: "100%",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: bgColor,
    opacity,
    fontSize: size,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "u-spin-core",
    style: _normalizeStyle(_unref(style))
  }, [
    _createVNode(Icon, { color: _unref(logoColor) }, null, 8, ["color"])
  ], 4))
}
}

})